export default {
  WithoutItemCard: {
    field: {
      title: 'Todavía no tienes lote activo',
      text: 'Todas tus lotes aparecerán aquí.',
      create_field: 'Crear lote',
    },
    sowing: {
      title: 'Todavía no tienes siembras activas en la zafra actual',
      text: 'Todas tus siembras de la zafra actual aparecerán aquí.',
      execute_sowing: 'Realizar la siembra',
    },
    filter: {
      not_found_title: 'No encontramos resultados',
      not_found_text: 'Prueba a cambiar los filtros',
    },
    integrations: {
      title: 'Todavía no tienes integración activa',
      text: 'Todas tus integraciones aparecerán aquí.',
      add_integration: 'Agregar integración',
    },
  },
  FarmDisabled: {
    farm_disabled: 'Farm disabled',
    farm_disabled_message_banner_text1: 'Habilite la hacienda para registrar',
    farm_disabled_message_banner_text2:
      'Solo podrás registrar si tu hacienda está habilitada. Haga clic en el botón de abajo para administrar las haciendas.',
    manager_farms: 'Gerenciar haciendas',
  },
}
